var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M14.3164 27.65L21.9497 20L14.3164 12.35L16.6664 10L26.6664 20L16.6664 30L14.3164 27.65Z","fill":"black"}})])}
var staticRenderFns = []

export { render, staticRenderFns }